import React from 'react';
import PropTypes from 'prop-types';
// import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { colors, typography } from '../styles';

const styles = css`
  .Link_Label {
    color:  ${colors.color1};
    font:700 14px/1 ${typography.SansSerif};
    padding:0;
    text-transform: uppercase;
    display:flex;
    flex-flow: row nowrap;
    transition: all .25s ease;
    @media (min-width: 768px) {
      font:700 30px/1 ${typography.SansSerif};
      padding:20px 0;
    }
  }
  .Link_Label:hover {
    color:  ${colors.color1Darkest};
  }
  .Link_Label small {
    color:  ${colors.color5};
    font:italic 400 10px/1 ${typography.SansSerif};
    padding:0;
    text-transform: capitalize;
    display:block;
    @media (min-width: 768px) {
      font:italic 400 16px/1 ${typography.SansSerif};
    }
  }
  .Link_Label img {
    margin-left:10px;
    @media (min-width: 768px) {

    }
  }
  .Link_Previous img {
    margin-right:10px;
    transform: rotate(180deg);
  }
  .Link_Next .Link_Label {
    float: right;
    text-align: right;
  }
`;

function IterationNavigation({ homes, routeName, currentHome, label }) {
  const currentIndex = homes.indexOf(currentHome);
  const prevHome = (currentIndex - 1) > -1 ? homes[currentIndex - 1] : undefined;
  const nextHome = (currentIndex + 1) < homes.length ? homes[currentIndex + 1] : undefined;

  return (
    <div className={styles}>
      <div className="container">
        <div className="row">
          <div className="col-6 Link_Previous">
            {
              prevHome &&
              <Link name={routeName} home={prevHome} className="Link_Label">
                <img src="/images/icon-arrow-two.jpg" alt="" />
                <span>
                  Previous {label}
                </span>
              </Link>
            }
          </div>
          <div className="col-6 Link_Next">
            {
              nextHome &&
              <Link name={routeName} home={nextHome} className="Link_Label">
                <span>
                  Next {label}
                </span>
                <img src="/images/icon-arrow-two.jpg" alt="" />
              </Link>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

IterationNavigation.propTypes = {
  currentHome: PropTypes.object.isRequired,
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
  label: PropTypes.string,
  routeName: PropTypes.string,
};

IterationNavigation.defaultProps = {
  label: 'Home',
  routeName: 'home-detail',
};

export default IterationNavigation;



// WEBPACK FOOTER //
// ./src/components/IterationNavigation.js